module.exports = __webpack_public_path__ + "static/media/golf_icon.4c854a93.svg";